var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6264 0.320033C13.6789 -0.106678 14.3211 -0.106678 14.3736 0.320033L14.8141 3.89975C15.3829 8.52213 19.1622 12.1665 23.9558 12.715L27.6681 13.1397C28.1106 13.1904 28.1106 13.8096 27.6681 13.8603L23.9558 14.285C19.1622 14.8335 15.3829 18.4779 14.8141 23.1002L14.3736 26.6799C14.3211 27.1067 13.6789 27.1067 13.6264 26.6799L13.1859 23.1002C12.6171 18.4779 8.83776 14.8335 4.04418 14.285L0.331886 13.8603C-0.110629 13.8096 -0.110629 13.1904 0.331886 13.1397L4.04418 12.715C8.83776 12.1665 12.6171 8.52213 13.1859 3.89975L13.6264 0.320033Z",
    fill: "#FFDC6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarAlt);
export default __webpack_public_path__ + "static/media/star_alt.968c681508b9d0d2506971e84d38d01c.svg";
export { ForwardRef as ReactComponent };